import type { Types } from '../../types';
import { computesDefaultIntervalId } from './intervals';
import { min2hrs, toTimeFloat } from './util/util';
import type { ConnectedTypes } from '../../make-connected';
import { getVertexId } from '../../../core/util';

export function parseDefault (
  settings:   ConnectedTypes.divisionSettings,
  options:    Types.parsedToOptions
): Types.Entities.DefaultValues {
  const res: Types.Entities.DefaultValues = {
    intervals: computesDefaultIntervalId(settings, options),
    period:    settings.period ? getVertexId(settings.period, options) : undefined,

    minGroupBreakDuration:      settings.defaultGroupMinimumBreakLength      ?? 0,
    minDependencyBreakDuration: settings.defaultDependencyMinimumBreakLength ?? 0,
    minEventBreakDuration:      settings.defaultEventMinimumBreakLength      ?? 0,

    preferredTime: toTimeFloat(settings.potentialCenter ?? '12:00'),
    eventDensity:  settings.defaultEventDensity ?? 1,

    maxEventDurationVariance: settings.defaultEventDurationVariance ?? 0,

    maxNumWorkingHours:      min2hrs(settings.defaultMaximumScheduleSpan?.weekly) ?? false,
    maxNumDailyWorkingHours: min2hrs(settings.defaultMaximumScheduleSpan?.daily ) ?? false,

    dependencyRank: settings.defaultDependencyRank ?? 0,
    groupRank:      settings.defaultGroupRank      ?? 0,
    dayRank:        settings.defaultDayRank        ?? 0,

    groupWeight: settings.defaultGroupWeight  ?? 0,
    eventWeight: settings.defaultEventWeight  ?? 0,
  };

  return res;
};